import { render, staticRenderFns } from "./UpsertTournamentBeneficiaryModal.vue?vue&type=template&id=7cb27c94&scoped=true"
import script from "./UpsertTournamentBeneficiaryModal.vue?vue&type=script&lang=js"
export * from "./UpsertTournamentBeneficiaryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb27c94",
  null
  
)

export default component.exports